export default {
  1: {
    ETHRegistrarControllerAddress: '0x253553366Da8546fC250F225fe3d25d0C782303b',
    ReverseRegistrarAddress: '0xA0a1AbcDAe1a2a4A2EF8e9113Ff0e02DD81DC0C6'
  },
  // HOLESKY
  17000: {
    ETHRegistrarControllerAddress: '0x179Be112b24Ad4cFC392eF8924DfA08C20Ad8583',
    ReverseRegistrarAddress: '0x132AC0B116a73add4225029D1951A9A707Ef673f'
  },
  // SEPOLIA
  11155111: {
    ETHRegistrarControllerAddress: '0xFED6a969AaA60E4961FCD3EBF1A2e8913ac65B72',
    ReverseRegistrarAddress: '0xa58E81fe9b61B5c3fE2AFD33CF304c454AbFc7Cb'
  }
};
